import {
    IonToolbar,
    IonButtons,
    IonBackButton,
    isPlatform,
    IonTitle,
} from "@ionic/react";
import { useParams } from "react-router";

export const Toolbar = () => {
    const { id }: { id: string } = useParams();

    return (
        <IonToolbar>
            <IonButtons slot="start">
                <IonBackButton
                    text={isPlatform("ios") ? "Plantilla" : ""}
                    defaultHref={`/app/tic/plantillas-file/detalle/${id}`}
                    color="light"
                />
            </IonButtons>
            <IonTitle>Asigna Usuarios</IonTitle>
        </IonToolbar>
    );
};
